import React, { useState, useEffect } from "react";

const StatusBar = ({ appData, extensionConnected }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const getStatusInfo = () => {
    if (appData.activeSession) {
      if (appData.isPaused) {
        return {
          icon: "ph-pause-circle",
          text: "Session Paused",
          bgColor: "bg-yellow-100",
          textColor: "text-yellow-800",
          borderColor: "border-yellow-200",
        };
      } else {
        return {
          icon: "ph-play-circle",
          text: "Active Session",
          bgColor: "bg-green-100",
          textColor: "text-green-800",
          borderColor: "border-green-200",
        };
      }
    } else {
      return {
        icon: "ph-circle",
        text: "Ready",
        bgColor: "bg-gray-100",
        textColor: "text-gray-800",
        borderColor: "border-gray-200",
      };
    }
  };

  const status = getStatusInfo();

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 mb-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-4">
          <div
            className={`flex items-center gap-3 px-4 py-3 rounded-xl border-2 ${status.bgColor} ${status.textColor} ${status.borderColor}`}
          >
            <i className={`ph ${status.icon} text-xl`}></i>
            <span className="font-bold">{status.text}</span>
          </div>

          {appData.activeSession && (
            <div className="flex items-center gap-3 px-4 py-3 rounded-xl bg-red-100 text-red-800 border-2 border-red-200">
              <i className="ph ph-shield-slash text-xl"></i>
              <span className="font-bold">
                {appData.blockedSites.length} sites blocked
              </span>
            </div>
          )}

          <div
            className={`flex items-center gap-3 px-4 py-3 rounded-xl border-2 ${
              extensionConnected
                ? "bg-green-100 text-green-800 border-green-200"
                : "bg-red-100 text-red-800 border-red-200"
            }`}
          >
            <i
              className={`ph ${
                extensionConnected ? "ph-link" : "ph-warning"
              } text-xl`}
            ></i>
            <span className="font-bold text-sm">
              {extensionConnected
                ? "Extension Connected"
                : "Extension Disconnected"}
            </span>
          </div>
        </div>

        <div className="text-right text-gray-600">
          <div className="font-bold text-lg flex items-center gap-2">
            <i className="ph ph-clock text-gray-500"></i>
            {currentTime.toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}
          </div>
          <div className="text-sm font-medium flex items-center gap-2">
            <i className="ph ph-calendar text-gray-400"></i>
            {currentTime.toLocaleDateString("en-US", {
              weekday: "short",
              month: "short",
              day: "numeric",
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusBar;
